/*
  Authors : initappz (Rahul Jograna)
  Website : https://initappz.com/
  App Name : ionic 5 groceryee app
  Created : 10-Sep-2020
  This App Template Source code is licensed as per the
  terms found in the Website https://initappz.com/license
  Copyright and Good Faith Purchasers © 2020-present initappz.
*/
import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  oneSignalObject: any;
  title = "app";

  constructor(private router: Router) {}

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    var OneSignal = window["OneSignal"] || [];
    console.log("Init OneSignal");
    // OneSignal.push([
    //   "init",
    //   {
    //     appId: "455779a0-eb35-4449-a887-d1816ef26f10",
    //     autoRegister: true,
    //     allowLocalhostAsSecureOrigin: true,
    //     notifyButton: {
    //       enable: true,
    //     },
    //   },
    // ]);
    // console.log("OneSignal Initialized");
    // OneSignal.push(function () {
    //   console.log("Register For Push");
    //   OneSignal.push(["registerForPushNotifications"]);
    // });
    // OneSignal.push(function () {
    //   // Occurs when the user's subscription changes to a new value.
    //   OneSignal.on("subscriptionChange", function (isSubscribed) {
    //     console.log("The user's subscription state is now:", isSubscribed);
    //     OneSignal.getUserId().then(function (userId) {
    //       console.log("User ID is", userId);
    //       localStorage.setItem("fcm", userId);
    //     });
    //   });
    // });
  }
}
